import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';

@Component({
  selector: 'scaffold-json',
  templateUrl: './scaffold-json.component.html',
  styleUrls: ['./scaffold-json.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScaffoldJsonComponent extends BaseScaffoldComponent implements OnInit {

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit(): void {
  }

}
